module.exports = __webpack_public_path__ + "static/media/connor.bfd0b3f2.jpg";